/**
 *
 * validateMobileNumberSchema
 *
 */
export class validateMobileNumberSchema {
  private readonly phoneNumber: string;
  private readonly countryCode: string;
  private readonly response: any;
  constructor(requestParameters: any) {
    this.phoneNumber = requestParameters.phoneNumber;
    this.countryCode = requestParameters.countryCode !== "US" ? requestParameters.countryCode : "";
    this.response = {
      status: true,
      countryCode: true,
      phoneNumber: true,
      atType: true,
      atBaseType: true,
    };
  }
  validateMobileNumber() {
    return {
      query: {
        validatePhoneNumber: {
          __args: {
            input: {
              phoneNumber: this.phoneNumber,
              countryCode: this.countryCode
            }
          },
          ...this.response,
        },
      },
    };
  }
}
